<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-4" elevation="0">
          <v-card-title class="d-flex align-center pb-0 pt-4 px-6">
            <h2 class="text-h5 font-weight-bold primary--text mb-0">
              Estadísticas
            </h2>
            <v-chip color="info" dark small class="ml-3 font-weight-bold elevation-1">
              Videos Verificados
            </v-chip>
            <v-spacer></v-spacer>
          </v-card-title>
          
          <v-card-text class="px-6 pb-6 pt-4">
            
            <!-- Filters Header -->
            <v-card class="filter-card pa-4 mb-6 rounded-lg elevation-1">
              <v-row align="center">
                <v-col cols="12" md="3" lg="3">
                  <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        v-model="fecha_inicio" 
                        label="Fecha Inicio" 
                        prepend-inner-icon="mdi-calendar-start" 
                        readonly 
                        v-bind="attrs" 
                        v-on="on" 
                        dense 
                        outlined 
                        rounded
                        hide-details
                        color="primary"
                        class="date-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha_inicio" @input="menu1 = false; initialize()" locale="es-mx" color="primary"></v-date-picker>
                  </v-menu>
                </v-col>
                
                <v-col cols="12" md="3" lg="3">
                  <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        v-model="fecha_fin" 
                        label="Fecha Fin" 
                        prepend-inner-icon="mdi-calendar-end" 
                        readonly 
                        v-bind="attrs" 
                        v-on="on" 
                        dense 
                        outlined 
                        rounded
                        hide-details
                        color="primary"
                        class="date-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha_fin" @input="menu2 = false; initialize()" locale="es-mx" color="primary"></v-date-picker>
                  </v-menu>
                </v-col>
                
                <v-col cols="12" md="4" lg="4">
                  <v-text-field 
                    label="Buscar recepcionista..." 
                    dense 
                    outlined 
                    rounded
                    hide-details 
                    prepend-inner-icon="mdi-magnify" 
                    v-model="search"
                    class="search-input"
                    color="primary"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="12" md="2" lg="2" class="text-right d-flex justify-end">
                  <v-btn color="primary" dark rounded class="premium-btn font-weight-bold px-5" @click="initialize()">
                    <v-icon left>mdi-refresh</v-icon> Actualizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <!-- Loading State -->
            <v-row v-if="cargar" justify="center" class="py-12">
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            </v-row>

            <!-- Empty State -->
            <v-row v-else-if="estadisticasFiltradas.length === 0" justify="center" class="py-12 text-center">
              <v-col cols="12" md="6">
                <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-chart-box-outline</v-icon>
                <h3 class="text-h6 grey--text font-weight-medium text--darken-2">No hay información</h3>
                <p class="grey--text">No se encontraron estadísticas en el rango de fechas seleccionado.</p>
              </v-col>
            </v-row>

            <!-- Stats Grid -->
            <v-row v-else>
              <v-col
                v-for="(item, index) in estadisticasFiltradas"
                :key="index"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                xl="2"
              >
                <v-card class="stat-card rounded-lg transition-swing hover-lift" elevation="2">
                  <v-card-text class="pa-5">
                    
                    <div class="d-flex align-center mb-4">
                      <v-avatar size="48" color="primary lighten-5" class="mr-3">
                        <span class="primary--text font-weight-bold text-h6">{{ item.recepcionista ? item.recepcionista.charAt(0).toUpperCase() : 'U' }}</span>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-bold text-truncate" style="max-width: 150px;" :title="item.recepcionista">
                          {{ item.recepcionista || 'Desconocido' }}
                        </div>
                        <div class="text-caption grey--text font-weight-medium">Recepcionista</div>
                      </div>
                    </div>

                    <v-divider class="mb-4"></v-divider>

                    <v-row no-gutters class="text-center mb-3">
                      <v-col cols="6" class="px-1">
                        <div class="metric-box bg-success-light rounded-lg pa-2">
                          <div class="text-caption success--text font-weight-bold text-uppercase mb-1">Aceptados</div>
                          <div class="text-h4 success--text font-weight-black">{{ item.videos_buenos }}</div>
                        </div>
                      </v-col>
                      <v-col cols="6" class="px-1">
                        <div class="metric-box bg-error-light rounded-lg pa-2">
                          <div class="text-caption error--text font-weight-bold text-uppercase mb-1">Rechazados</div>
                          <div class="text-h4 error--text font-weight-black">{{ item.videos_malos }}</div>
                        </div>
                      </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                      <v-col cols="12">
                         <div class="total-box rounded-lg px-4 py-2 d-flex justify-space-between align-center">
                            <span class="text-subtitle-2 grey--text text--darken-2 font-weight-bold">Videos Totales</span>
                            <v-chip color="grey darken-3" dark small class="font-weight-black">{{ item.total_videos }}</v-chip>
                         </div>
                      </v-col>
                    </v-row>
                    
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';
import moment from "moment";
import { mapGetters } from 'vuex';
moment.locale('es');

export default {
  mixins: [validarErrores],
  components: { Alerta, carga },
  props: {
    escuelaProp: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargar: false,
    search: '',
    menu1: false,
    menu2: false,
    fecha_inicio: moment().startOf('month').format("YYYY-MM-DD"),
    fecha_fin: moment().endOf('month').format("YYYY-MM-DD"),
    estadisticas: []
  }),
  computed: {
    ...mapGetters("login", ["getdatosUsuarioERPERP"]),
    estadisticasFiltradas() {
      if (!this.search) return this.estadisticas;
      const term = this.search.toLowerCase();
      return this.estadisticas.filter(e => {
        return (e.recepcionista && e.recepcionista.toLowerCase().includes(term));
      });
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    escuelaProp() {
      this.initialize();
    }
  },
  methods: {
    initialize() {
        if (!this.fecha_inicio || !this.fecha_fin) return;
        this.cargar = true;
        this.estadisticas = [];
        
        const payload = {
            escuela: this.escuelaProp,
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin
        };

        this.$http.post('videos.merca.estadisticas', payload)
            .then(response => {
                const estadisticas = response.data;

                if([12,97,25,48,74,11,43,74,97,101,25].includes(this.getdatosUsuarioERPERP.idpuesto)){
                  this.estadisticas = estadisticas
                }else{
                  this.estadisticas = estadisticas.filter(e => {
                    return e.id_usuario == this.getdatosUsuarioERPERP.id_usuario;
                  });
                }
            })
            .catch(error => {
                const msg = (error.response && error.response.data) ? error.response.data.message : 'Error al obtener estadísticas';
                this.validarError(msg);
            })
            .finally(() => {
                this.cargar = false;
            });
    }
  }
};
</script>

<style scoped>
/* Glassmorphism & Cards */
.glass-card {
  background: white !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04) !important;
  border-radius: 16px !important;
}

.filter-card {
  background: linear-gradient(145deg, #ffffff, #f5f7fa);
  border: 1px solid rgba(0,0,0,0.03);
}

.stat-card {
  border: 1px solid rgba(0,0,0,0.04) !important;
  background: white !important;
  height: 100%;
}

.hover-lift {
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease;
}

.hover-lift:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 32px -8px rgba(0,0,0,0.1) !important;
  border-color: rgba(0,0,0,0.08) !important;
}

/* Colors & Metrics */
.bg-success-light {
  background-color: #f1fbf5;
  border: 1px solid #e8f5e9;
}

.bg-error-light {
  background-color: #fff5f5;
  border: 1px solid #ffebee;
}

.total-box {
  background-color: #f5f7fa;
  border: 1px solid #eeeeee;
}

/* Buttons */
.premium-btn {
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.premium-btn:hover {
  transform: translateY(-2px);
}


/* Inputs */
.search-input .v-input__control > .v-input__slot,
.date-input .v-input__control > .v-input__slot {
  background: white !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.03) !important;
}
</style>
